export class ClickStream {
    gmid: string;
    site: string = 'third-party';
    sessionId: string;
    isUserAction: boolean;
    eventType: string;
    eventName: string;
    url: string;
    pageTitle: string;
    area: string;
    value: string;
    browser: string;
    browserHeight: number;
    browserWidth: number;
    screenHeight: number;
    screenWidth: number;
}